const COLS = [['points', 'PTS'], ['rebounds', 'REB'], ['assists', 'AST'], ['threes', '3PM'], ['blocks', 'BLK']];
const rankTone = (r) => (r == null ? 'text-zinc-500' : r <= 10 ? 'text-emerald-300' : r >= 21 ? 'text-red-300' : 'text-zinc-300');
const fmt = (v) => (v == null ? '—' : v);

const StatCell = ({ s }) => (
  <div className="rounded bg-zinc-900 px-1 py-0.5 text-center">
    <p className="font-mono text-xs font-bold text-white">{fmt(s?.season)}</p>
    <p className="text-[9px] text-zinc-400">L5 {fmt(s?.last5)}</p>
    <p className={`text-[9px] ${s?.vs?.length ? 'text-amber-300' : 'text-zinc-600'}`}>{s?.vs?.length ? `vs ${s.vs.join('/')}` : 'vs —'}</p>
  </div>
);

const Row = ({ p, oppAbbr }) => {
  const b = p.breakdown;
  const dd = b.stats.dd;
  return (
    <li className="space-y-1 border-t border-zinc-800 pt-1.5" data-testid={`nba-bd-player-${p.player_id}`}>
      <p className="flex items-center gap-1 text-[11px]">
        <span className="font-bold text-white">{p.name}</span>
        <span className="text-zinc-500">{p.role} · {fmt(b.min)} min{p.bench ? ' · bench' : ''}</span>
        {b.season_label !== 'Season' && <span className="rounded bg-zinc-700 px-1 text-[9px] text-zinc-200" data-testid={`nba-bd-last-season-${p.player_id}`}>last season</span>}
        {p.injury?.status && <span className="rounded bg-red-500/20 px-1 text-[9px] font-bold text-red-200">{p.injury.status}</span>}
        <span className="ml-auto text-[9px] text-zinc-500">{b.vs_games ? `${b.vs_games}× vs ${oppAbbr}` : `no ${oppAbbr} game yet`}</span>
      </p>
      <div className="grid grid-cols-6 gap-1">
        {COLS.map(([k]) => <StatCell key={k} s={b.stats[k]} />)}
        <div className="rounded bg-zinc-900 px-1 py-0.5 text-center" data-testid={`nba-bd-dd-${p.player_id}`}>
          <p className="font-mono text-xs font-bold text-white">{dd.season}/{dd.games}</p>
          <p className="text-[9px] text-zinc-400">L5 {dd.last5}</p>
          <p className={`text-[9px] ${b.vs_games ? 'text-amber-300' : 'text-zinc-600'}`}>{b.vs_games ? `vs ${dd.vs}` : 'vs —'}</p>
        </div>
      </div>
    </li>
  );
};

// Every rotation player: season avg, last 5, earlier games vs tonight's opponent, and the opponent's defense rank per stat.
export const NbaTeamBreakdown = ({ team, opp, players }) => {
  const list = players.filter((p) => p.breakdown);
  if (!list.length) return null;
  const rk = opp?.defense_rank || {};
  return (
    <details className="mt-2 rounded-lg border border-sky-500/30 bg-sky-500/5 p-2" data-testid={`nba-breakdown-${team.abbr}`}>
      <summary className="cursor-pointer text-[11px] font-bold text-sky-300" data-testid={`nba-breakdown-toggle-${team.abbr}`}>
        Every {team.abbr} player vs {opp?.abbr} · {list.length} players (tap)
      </summary>
      <div className="mt-2 grid grid-cols-6 gap-1 text-center text-[9px] font-bold text-zinc-400">
        {COLS.map(([k, l]) => (
          <div key={k}>{l}<p className={rankTone(rk[k])} data-testid={`nba-def-rank-${team.abbr}-${k}`}>{rk[k] ? `${opp.abbr} D #${rk[k]}` : '—'}</p></div>
        ))}
        <div>DD<p className="text-zinc-500">season</p></div>
      </div>
      <p className="mt-1 text-[9px] text-zinc-500">Big number = season avg · L5 = last 5 avg · vs = each game vs {opp?.abbr} this season · D #1 = gives up the most</p>
      <ul className="mt-1 space-y-1.5">{list.map((p) => <Row key={p.player_id} p={p} oppAbbr={opp?.abbr} />)}</ul>
    </details>
  );
};

export default NbaTeamBreakdown;
